import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import DropdownMenu from './Dropdown'
import ContentEditor from './EmailContentEditor'
import _ from "lodash";
function Page(props) {
    const [isloading, setisloading] = useState(false);
    const data = props.data?.email||[]


    {/*content handler*/ }
    const handleContentOrder = (field) => (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data[field][oldIndex]);
        }
        if (props.onEdit) {
            props.onEdit('email', { ...(props.data?.email || {}), [field]: array })
        }
        
    }
    const handleAddContent = (field) => () => {
        let d = { ...data };
        let c = [...(d[field] || [])]
        c.push({ id: Date.now(), type: '電郵內容', content: '', isTitle: false })
        d[field] = c
        if (props.onEdit) {
            props.onEdit('email', d)
        }
    }
    const handleSectionDeleteContent = (field) => (card, cardIndex) => {
        let d = { ...data }
        let c = d?.[field] || [];
        c.splice(cardIndex, 1);
        d[field] = c;
        if (props.onEdit) {
            props.onEdit('email', d)
        }
    }
    const handleSectionEditContent = (field) => (card, cardIndex, key, value) => {
        let d = { ...data };
        d[field][cardIndex][key] = value
        if (props.onEdit) {
            props.onEdit('email', d)
        }
    }
    {/*content handler*/ }


    const [isShowPreview, setisShowPreview] = useState(false);

    return (
        <div className="w-full h-full flex flex-col items-start justify-start bg-[#ddd] overflow-hidden p-[16px] gap-[8px]" style={{ overflowY: 'auto' }}>


            <div className='w-full flex flex-row justify-between items-start gap-[16px]'>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>發送{props.type==='register'?'登記':"批准"}電郵</div>
                    <DropdownMenu options={['發送', '不發送']}
                        value={props.data?.email?.[props.type==='register'?'enableRegistrationEmail':"enableApprovalEmail"] ? '發送' : '不發送'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('email', { ...(props.data?.email || {}), [props.type==='register'?'enableRegistrationEmail':"enableApprovalEmail"]: item === '發送' })
                            }
                        }}
                    />
                </div>
                
                <div onClick={()=>{setisShowPreview(true)}}className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)'}}>
                    預覽電郵    
                </div>
            </div>
            <div className='font-[700] mt-[16px]'>{props.type==='register'?'登記':"批准"}電郵標題</div>
            <input className='w-full p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                value={props.data?.email?.[props.type==='register'?'registrationEmailTitle':"approvalEmailTitle"] || ''}
                onChange={(e) => {
                    if (props.onEdit) {
                        props.onEdit('email', { ...(props.data?.email || {}), [props.type==='register'?'registrationEmailTitle':"approvalEmailTitle"]: e.target.value })
                    }
                }}
            />

            <ContentEditor
                data={data}
                field={props.type==='register'?'registrationEmailContents':'approvalEmailContents'}
                refresh={props.refresh}
                onDelete={handleSectionDeleteContent(props.type==='register'?'registrationEmailContents':'approvalEmailContents')}
                onAddCard={handleAddContent(props.type==='register'?'registrationEmailContents':'approvalEmailContents')}
                onEditKey={handleSectionEditContent(props.type==='register'?'registrationEmailContents':'approvalEmailContents')}
                updateOrder={handleContentOrder(props.type==='register'?'registrationEmailContents':'approvalEmailContents')}
            />

            {/* <div className='font-[700]'>登記電郵內容</div>
            <textarea className='w-full min-h-[200px] p-[8px] border-[1px] border-[#00000020] rounded-[4px]'
                value={props.data?.email?.registrationEmailContent}
                onChange={(e) => {
                    if (props.onEdit) {
                        props.onEdit('email', { ...(props.data?.email || {}), registrationEmailContent: e.target.value })
                    }
                }}
            />
            <div className='font-[700]'>批准電郵內容</div>
            <textarea className='w-full min-h-[200px] p-[8px] border-[1px] border-[#00000020] rounded-[4px]'
                value={props.data?.email?.approvalEmailContent}
                onChange={(e) => {
                    if (props.onEdit) {
                        props.onEdit('email', { ...(props.data?.email || {}), approvalEmailContent: e.target.value })
                    }
                }}
            />> */}


            {isShowPreview &&
                <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] bg-[#00000080] flex items-center justify-center">
                    <div className="bg-[white] p-[16px] rounded-[7px] w-full max-w-[800px] relative max-h-[80vh] overflow-y-auto">
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer" onClick={() => { setisShowPreview(false) }}>
                           x
                        </div>

                        <div className='font-[700]'>電郵標題: {props.data?.email?.[props.type==='register'?'registrationEmailTitle':'approvalEmailTitle']||''}</div>

                        <div className='font-[700] mt-[8px]'>電郵內容:</div>
                        <div className="bg-[#f0f0f0]">
                        {props.data?.email?.[props.type==='register'?'registrationEmailContents':'approvalEmailContents']?.map((item, index) => 
                                <div key={index} className=" p-[8px] rounded-[4px] mb-[8px]">
                                    {item.type === '電郵內容' && <div dangerouslySetInnerHTML={{ __html: item.data || '' }} />}
                                    {item.type === '敬語' && <div>{item.data || ''} 
                                         <span className="font-bold"> ##[User Name]##,</span>
                                    </div>}
                                    {item.type === '個人二維碼' && <div className="font-bold">##[User QR Code]##</div>}
                                    {item.type === '圖片' && <img src={item.url} alt="Email Content" onClick={()=>{
                                        if(item.allowUrlRedirect && item.redirectUrl){
                                            window.open(item.redirectUrl, '_blank');
                                        }
                                    }} className="h-auto rounded-[4px] cursor-pointer" style={{width: item.width || '100%'}}/>}
                                </div>
                            )
                        }
                        </div>
                    </div>
                </div>
            }

            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
